import { useCallback } from 'react';

export const useDestroy = (upload) => {
  const destroy = useCallback(
    (e) => {
      e.stopPropagation();
      confirm('Supprimer le fichier ?') && upload.destroy();
    },
    [upload],
  );
  return destroy;
};
